import {
    FETCH_MARKETING_CAMPAIGNS,
    CREATE_MARKETING_CAMPAIGNS,
    UPDATE_MARKETING_CAMPAIGNS,
    DELETE_MARKETING_CAMPAIGN,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MARKETING_CAMPAIGNS:
            return action.payload;
        case CREATE_MARKETING_CAMPAIGNS:
            return state.concat(action.payload);
        case UPDATE_MARKETING_CAMPAIGNS:
            return state.filter(c => c.id !== action.payload.id).concat(action.payload);
        case DELETE_MARKETING_CAMPAIGN:
            return state.filter(c => c.id !== action.payload.campaignId);
        default:
            return state;
    }
};
